module.exports = __webpack_public_path__ + "static/media/icon_reset.afbec75a.svg";